import React from 'react';
import ReactDOM from 'react-dom';

import 'components/assets/sass/index.scss';

import routes from './routes/Routes';
import Root from './Root';
import { store, browserHistory } from './redux/store/configureStore';
import moment from 'moment';

import 'moment/locale/ru';

moment.locale('ru');

ReactDOM.render(
    <Root history={browserHistory} routes={routes} store={store} />,
    document.getElementById('root'),
);
